import { createApi } from '@reduxjs/toolkit/query/react';
import { config } from '../../config/config';
import customFetchBase from '../expiredToken/expiredToken';

const customFetch = customFetchBase(config.baseUrlDealers);

export const apiWebJobs = createApi({
  baseQuery: customFetch,
  endpoints: (builder) => ({
    eventProcessorSync: builder.mutation<null, null>({
      query: () => ({
        url: `api/WebJob/EventProcessorSync`,
        method: 'POST',
        body: { WebJobName: 'EventProcessor.SyncEvents' }
      })
    })
  })
});

export const { useEventProcessorSyncMutation } = apiWebJobs;
